<template>
  <div class="center">
    <PvTodayEnergyOverview />

    <div class="panel center-map">
      <PvLeafletMap ref="leafMap" />
      <PvDeviceEnvPanel />
    </div>

    <div class="panel center-bottom">
      <div class="panel-title pv-panel-title-row">
        📈 能耗趋势（7日）
        <a
          href="#"
          class="pv-export-link"
          @click.prevent="onExportTrend"
          >📥 导出</a
        >
      </div>
      <PvTrendChart ref="trendChart" />
    </div>
  </div>
</template>

<script>
import PvTodayEnergyOverview from "./childrens/PvTodayEnergyOverview.vue";
import PvLeafletMap from "./childrens/PvLeafletMap.vue";
import PvDeviceEnvPanel from "./childrens/PvDeviceEnvPanel.vue";
import PvTrendChart from "./childrens/PvTrendChart.vue";

export default {
  name: "PvCenterColumn",
  components: {
    PvTodayEnergyOverview,
    PvLeafletMap,
    PvDeviceEnvPanel,
    PvTrendChart,
  },
  methods: {
    onExportTrend() {
      const tc = this.$refs.trendChart;
      if (tc && typeof tc.exportWeeklyTrend === "function") {
        tc.exportWeeklyTrend();
      }
    },
    resizeCenterCharts() {
      const trend = this.$refs.trendChart;
      const mapRef = this.$refs.leafMap;
      if (trend && trend.resizeChart) trend.resizeChart();
      if (mapRef && mapRef.invalidate) mapRef.invalidate();
    },
  },
};
</script>
